/**
 * Value for the configuration property within a ComponentInstanceConfig.
 * 
 * @export
 * @class ComponentInstanceConfigConfiguration
 */
export class ComponentInstanceConfigConfiguration {
    [configName: string]: any;
}